const initialKeyword = {
    keywordPermissions:{},
    keywordLists: [],
    keywordStatus: [],
    changedKeywordStatus : [],
    loadingKeyword: false,
    errorsKeyword: {}
}

const  keywordReducer = (state = initialKeyword, action) => {
    switch (action.type) {
        case "GET_KEYWORDLIST_PENDING":
        case "ADD_KEYWORD_PENDING":
        case "UPDATE_KEYWORD_PENDING":
        case "UPDATE_KEYWORD_STATUS_PENDING":
        case "DELETE_KEYWORD_PENDING":
        case "GET_KEYWORDLISTBYID_PENDING":
            return { ...state, loadingKeyword: true };

        case "GET_KEYWORDLIST_FULFILLED":
            return {
                ...state,
                loadingKeyword: false,
                keywordLists: action.payload,
                keywordCount: action.keywordCount,
                keywordPermissions:action.permissions,
            };

        case "ADD_KEYWORD_FULFILLED":
            return {
                ...state,
                loadingKeyword: false,
                changedKeywordStatus: action.payload,
            };

        case "UPDATE_KEYWORD_FULFILLED":
            return {
                ...state,
                loadingKeyword: false,
                changedKeywordStatus: action.payload,
            };

        case "UPDATE_KEYWORD_STATUS_FULFILLED":
                return {
                    ...state,
                    loadingKeyword: false,
                    changedKeywordStatus: action.payload,
                };

        case "GET_KEYWORDLISTBYID_FULFILLED":
            return {
                ...state,
                loadingKeyword: false,
                keywordLists: action.payload
            };

        case "DELETE_KEYWORD_FULFILLED":
            return {
                ...state,
                loadingKeyword: false,
                changedKeywordStatus: action.payload
            };

        case "RESET_DELETE_KEYWORD_STATUS":
            return {
                ...state,
                loadingKeyword: false,
                changedKeywordStatus: [],
                errorsKeyword:{}
            };

        case "GET_KEYWORDLIST_REJECTED":
        case "ADD_KEYWORD_REJECTED":
        case "UPDATE_KEYWORD_REJECTED":
        case "UPDATE_KEYWORD_STATUS_REJECTED":
        case "DELETE_KEYWORD_REJECTED":
        case "GET_KEYWORDLISTBYID_REJECTED":
            return {
                ...state,
                loadingKeyword: false,
                errorsKeyword: action.payload
            };

        default:
            return state;
    }
}

export default keywordReducer;